let liveCommunicationRoutes = [
    {
		path: '/live',
		name: 'Live',
        layout: 'live-communications',
        meta: {
            requiresAuth: false,
            allowAuthenticated: true,
            title: 'Live | Appointment Portal RDCD',        
            displayTitle: 'Live',
            
        },
		component: () => import(/* webpackChunkName: 'communications' */ '../pages/LiveCommunicationsPage.vue'),
	}
];
export { liveCommunicationRoutes };